var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIcEmail = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "auto",
  height: "auto",
  viewBox: "0 0 100 100",
  xmlns: "http://www.w3.org/2000/svg",
  className: "dd-privacy-hidden"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  fill: "#FFF",
  cx: 50,
  cy: 50,
  r: 50
}), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "m57.052 60.439-6.822-6.834a1.137 1.137 0 0 0-1.942.803v15.93a1.137 1.137 0 0 0 2.047.682l6.822-9.096a1.137 1.137 0 0 0-.105-1.485Z",
  fill: "#405B73"
}), /*#__PURE__*/React.createElement("path", {
  d: "m52.059 57.89-6.823-2.275a1.137 1.137 0 0 0-1.44 1.438l4.55 13.644c.154.465.59.778 1.08.778h.07a1.137 1.137 0 0 0 1.043-.91l2.274-11.37a1.137 1.137 0 0 0-.754-1.306Z",
  fill: "#F4CC54"
}), /*#__PURE__*/React.createElement("path", {
  d: "M75.09 26.21a1.137 1.137 0 0 0-1.22-.053L30.661 51.172a1.137 1.137 0 0 0 .211 2.062l20.421 6.809 15.873 6.804a1.137 1.137 0 0 0 1.567-.848l6.822-38.66a1.137 1.137 0 0 0-.466-1.13Z",
  fill: "#405B73"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#F4CC54"
}, /*#__PURE__*/React.createElement("path", {
  d: "M75.365 27.801a1.137 1.137 0 0 0-1.73-1.464L43.983 57.61l8.558 2.956L75.365 27.8ZM23.778 68.507c-.285 0-.56-.107-.77-.3a53.663 53.663 0 0 1-1.674-1.608 1.138 1.138 0 1 1 1.607-1.61 53.858 53.858 0 0 0 1.608 1.544 1.137 1.137 0 0 1-.77 1.974ZM39.27 76a16.366 16.366 0 0 1-3.262-.339 1.137 1.137 0 1 1 .455-2.226c.926.19 1.868.288 2.813.291h.519a1.078 1.078 0 0 1 1.18 1.094 1.137 1.137 0 0 1-1.094 1.178h-.594L39.27 76Zm-8.149-2.176c-.182 0-.361-.044-.523-.128a29.694 29.694 0 0 1-3.231-1.962 1.137 1.137 0 0 1 1.296-1.867c.953.67 1.948 1.278 2.979 1.819a1.137 1.137 0 0 1-.523 2.147l.002-.01ZM45.116 74.781a1.137 1.137 0 0 1-.455-2.183 16.51 16.51 0 0 0 1.903-.964 1.137 1.137 0 0 1 1.156 1.958c-.698.412-1.42.779-2.165 1.098-.14.06-.288.09-.44.091Z"
}))))));
export default SvgIcEmail;